<script setup>
import { ref, watch } from "vue"
import { ViewColumnsIcon } from '@heroicons/vue/24/solid'
import { PrimaryButton, Checkbox } from "@codinglabsau/ui"
import Modal from "@/Components/Inputs/BlockEditor/Extension/Components/Modal.vue"
import ToolbarButton from "@/Components/Inputs/BlockEditor/Extension/Components/ToolbarButton.vue"
import { useVModels } from "@vueuse/core"

const props = defineProps({
  cols: {
    required: true,
  },
  spacing: {
    required: true,
  },
  mobileCols: {
    required: false
  },
})

let showDialogue = ref(false)
let showMobileOptions = ref(props.mobileCols > 1)

const emits = defineEmits(['update:cols', 'update:spacing', 'update:mobileCols'])

const {
  cols: computedCols,
  spacing: computedSpacing,
  mobileCols: computedMobileCols,
} = useVModels(props, emits)

watch(showMobileOptions, updatedVal => {
  if (! updatedVal) {
    computedMobileCols.value = 1
  }
})
</script>

<template>
  <ToolbarButton :label="__('Edit Grid')" :icon="ViewColumnsIcon" v-model="showDialogue"/>
  <Modal v-model="showDialogue">
    <template #title>
      {{ __('Edit Grid') }}
    </template>
    <template #description>
      {{ __('Change the number of columns and spacing between for the grid.') }}
    </template>
    <div>
      <label for="cols">{{ __('Columns') }}</label>
      <input type="number" min="1" max="12" step="1" required v-model="computedCols">
    </div>
    <div>
      <label for="cols">{{ __('Spacing') }}</label>
      <select v-model="computedSpacing">
        <option value="0">{{ __('None') }}</option>
        <option value="1">{{ __('Small') }}</option>
        <option value="2">{{ __('Medium') }}</option>
        <option value="4">{{ __('Large') }}</option>
        <option value="6">{{ __('Extra Large') }}</option>
      </select>
    </div>
    <div>
      <Checkbox
        v-model="showMobileOptions"
        :label="__('Customise columns for mobile')"
      />
    </div>
    <div v-if="showMobileOptions">
      <input type="number" step="1" required v-model="computedMobileCols">
    </div>
    <PrimaryButton class="mt-2" type="button" @click.prevent="showDialogue = false">{{ __('Done') }}</PrimaryButton>
  </Modal>
</template>
